<template>
  <div
    v-if="info != null"
    class="filter-box"
  >
    <TextCustomFieldItem
      v-if="info.dataType === 'text'"
      :title="info.name"
      :value="(info.value as string)"
      :custom-field-item="customFieldItem"
      :field-key="fieldKey"
      is-display-only
    />
    <DateTimeFilterCommon
      v-else-if="info.dataType === 'datetime'"
      :title="info.name"
      :value="info.value"
      :key-name="fieldKey"
      :filter-param="(customFieldItem as TDateTimeFilterParam)"
      is-custom
      is-display-only
    />
    <OptionCustomFieldItem
      v-else-if="['option', 'multi_option'].includes(info.dataType)"
      :title="info.name"
      :value="(info.value as string)"
      :custom-field-item="customFieldItem"
      :field-key="fieldKey"
      is-display-only
    />
    <NumberCustomFieldItem
      v-else-if="info.dataType === 'number'"
      :title="info.name"
      :value="(info.value as TNumberValue)"
      :custom-field-item="(customFieldItem as TNumberFilterParam)"
      :key-name="fieldKey"
      is-display-only
    />
  </div>
  <BEmptyBox
    v-else
    class="filter-b-empty-box"
    display-only
  />
</template>

<script lang="ts" setup>
import NumberCustomFieldItem from '@/components/organisms/user/leadList/filter/detail/customFieldItem/NumberCustomFieldItem.vue';
import OptionCustomFieldItem from '@/components/organisms/user/leadList/filter/detail/customFieldItem/OptionCustomFieldItem.vue';
import TextCustomFieldItem from '@/components/organisms/user/leadList/filter/detail/customFieldItem/TextCustomFieldItem.vue';
import DateTimeFilterCommon from '@/components/organisms/user/leadList/filter/detail/DateTimeFilterCommon.vue';
import type { TFilterParam as TDateTimeFilterParam } from '@/components/organisms/user/leadList/filter/detail/DateTimeFilterCommon.vue';
import type { TValue as TNumberValue, TFilterParam as TNumberFilterParam } from '../filter/detail/NumberFilterCommon.vue';

type TProps = {
  info: { dataType: string, name: string, value: string | TNumberValue };
  customFieldItem: TDateTimeFilterParam | TNumberFilterParam;
  fieldKey: string;
};

defineProps<TProps>();
</script>
